import { FC } from 'react';
import classNames from 'classnames';
import getClassNames from 'src/common/utils/getClassNames';
import Typography from 'src/common/components/Typography';
import IconPictogram from 'src/common/components/IconPictogram';
import { useTranslation } from 'next-i18next';
import styles from './Address.module.scss';

export type AddressProps = {
  title?: string;
  subTitle?: string;
  iconColor?: 'green' | 'blue';
  leftAligned?: boolean;
  size?: 'body-m' | 'body-s';
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  sameAddress?: boolean;
};

const Address: FC<AddressProps> = ({
  title,
  subTitle,
  iconColor = 'blue',
  leftAligned = false,
  size = 'body-m',
  address,
  city,
  state,
  zip,
  country,
  sameAddress = false,
}) => {
  const { t } = useTranslation('listing-page');
  const addressLine1 = address;
  const addressLine2 = [city, state, zip].filter(Boolean).join(', ');
  const addressLine3 = country;

  return (
    <div>
      <div className={styles.titleContainer}>
        <IconPictogram
          id={`static-map-pin-${iconColor}`}
          size="m"
          alt={title}
          className={styles.titleIcon}
        />
        <Typography size="body-m" weight="semibold" type="p">
          {title}
        </Typography>
      </div>
      {subTitle && (
        <Typography size="body-s" type="span">
          {subTitle}
        </Typography>
      )}
      <address className={getClassNames(styles, 'addressContainer', classNames(size, {
        leftAligned,
      }))}
      >
        {sameAddress ? (
          <Typography size="body-m" type="span">
            {t('location-map--same-address')}
          </Typography>
        ) : (
          <>
            {addressLine1 && <div>{addressLine1}</div>}
            {addressLine2 && <div>{addressLine2}</div>}
            {addressLine3 && <div>{addressLine3}</div>}
          </>
        )}
      </address>

    </div>
  );
};

export default Address;
